import React from 'react';
import { Box, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { ThspianFullLogo } from '../../../components/ThspianLogo/ThspianFullLogo';

const MessageHeader: React.FC = () => {
    const { themeStyle } = useThemeContext();
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 2,
                borderBottom: `1px solid ${theme[themeStyle].grey}`,
                bgcolor: theme[themeStyle].secondaryBg,
            }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                }}>
                <IconButton
                    edge="start"
                    onClick={() => navigate('/')}
                    disableRipple
                    sx={{
                        mr: 1,
                        color: theme[themeStyle].true_highlight,
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: theme[themeStyle].true_highlight, // keep same color on hover
                        },
                        '&:active': { backgroundColor: 'transparent' }, // optional
                        // make sure the icon inside doesn't change either
                        '& svg': { color: theme[themeStyle].logo_color },
                        '&:hover svg': { color: theme[themeStyle].logo_color },
                    }}>
                    <ArrowBack sx={{ color: theme[themeStyle].logo_color }} />
                    <ThspianFullLogo
                        width={150}
                        height={30}
                        style={{ paddingLeft: 7 }}
                        fill={theme[themeStyle].logo_color}
                    />
                </IconButton>
            </Box>
        </Box>
    );
};

export default MessageHeader;
